const ActionTypes = {
  TRENDING_IS_ENABLED: 'TRENDING_IS_ENABLED',
};

export default ActionTypes;
